import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericServiceDeletionStatus } from '@starfish-access/models';
import { Observable } from 'rxjs';
import { SvcErrorDialogComponent } from './svc-error-dialog.component';

@Injectable()
export class SvcErrorDialogService {
  constructor(private dialog: MatDialog) {}

  errorDisplay(data: GenericServiceDeletionStatus): Observable<boolean> {
    const dialogRef: MatDialogRef<SvcErrorDialogComponent> = this.dialog.open(SvcErrorDialogComponent, {
      data,
      disableClose: true,
    });
    return dialogRef.afterClosed();
  }
}
